// ./src/components/features/Forms/FormFieldsEditModal/HexColorFieldOptionsEditor.tsx
import React from "react";
import { Stack, Switch, Select, Text, Group, ColorSwatch } from "@mantine/core";
import { HexColorFieldOptions } from "./fieldOptionsTypes";

export interface HexColorFieldOptionsEditorProps {
  value: HexColorFieldOptions;
  onChange: (options: HexColorFieldOptions) => void;
}

const FORMAT_OPTIONS = [
  { value: "both", label: "Both formats (default)" },
  { value: "short", label: "Short only (#RGB)" },
  { value: "long", label: "Long only (#RRGGBB)" },
];

export const HexColorFieldOptionsEditor: React.FC<
  HexColorFieldOptionsEditorProps
> = ({ value, onChange }) => {
  const handleChange = (field: keyof HexColorFieldOptions, fieldValue: any) => {
    onChange({
      ...value,
      [field]: fieldValue,
    });
  };

  return (
    <Stack gap="sm">
      <Text size="xs" c="dimmed">
        Validates hexadecimal color codes.
      </Text>

      <Group gap="xs">
        <ColorSwatch color="#F00" size={16} />
        <Text size="xs" c="dimmed">
          Short: #RGB (e.g., #F00)
        </Text>
        <ColorSwatch color="#FF5733" size={16} />
        <Text size="xs" c="dimmed">
          Long: #RRGGBB (e.g., #FF5733)
        </Text>
      </Group>

      <Select
        label="Accepted format"
        description="Which hex color formats to accept"
        data={FORMAT_OPTIONS}
        value={value.format ?? "both"}
        onChange={(val) =>
          handleChange("format", val === "both" ? undefined : val)
        }
        size="sm"
      />

      <Switch
        label="Require # prefix"
        description="Color must start with # symbol"
        checked={value.requireHash ?? true}
        onChange={(e) =>
          handleChange(
            "requireHash",
            e.currentTarget.checked ? undefined : false
          )
        }
        size="sm"
      />

      <Switch
        label="Allow alpha channel"
        description="Accept 8-character format with transparency (#RRGGBBAA)"
        checked={value.allowAlpha ?? false}
        onChange={(e) => handleChange("allowAlpha", e.currentTarget.checked)}
        size="sm"
      />
    </Stack>
  );
};
